import { Action, createAction } from 'redux-act';

import { SeatedReservation } from '../../../models/interfaces/reservation/Reservation';
import SpecialHour from '../../../models/interfaces/SpecialHour';
import TimestampPayload from '../TimestampPayload';
import SpecialHourAction from './SpecialHourAction';

export interface ModifySpecialHourPayload extends SpecialHourAction, TimestampPayload {
  placeUuid: string;
  specialHour: SpecialHour;
}
export const modifySpecialHour = createAction<ModifySpecialHourPayload>('MODIFY_SPECIAL_HOUR');
export type ModifySpecialHourActionType = Action<ModifySpecialHourPayload>;

export interface SpecialHourModifiedPayload extends SpecialHourAction, TimestampPayload {
  placeUuid: string;
  specialHour: SpecialHour;
  affectedReservations: SeatedReservation[];
}
export const specialHourModified = createAction<SpecialHourModifiedPayload>('SPECIAL_HOUR_MODIFIED');

export interface SpecialHourModifyFailedPayload extends SpecialHourAction, TimestampPayload {
  placeUuid: string;
  specialHourUuid: string;
}
export const specialHourModifyFailed = createAction<SpecialHourModifyFailedPayload>('SPECIAL_HOUR_MODIFY_FAILED');
